import {graneroInstance} from '@apps-common/geocorn-sdk/api';
import {getCollections} from '@apps-common/geocorn-sdk/api/collections';
import {useInfiniteQuery, useQuery} from '@tanstack/react-query';
import {DURATION_MS, getQueryKeys} from './util.js';

export const queryKeys = getQueryKeys('featureCollections');

// ToDo: this should probably come from geocorn-sdk
const validateFeature = feature =>
  graneroInstance
    .post('/ogc/my/collections/validate', feature)
    .then(res => res.data);

const getAlternates = feature =>
  graneroInstance
    .post('/ogc/my/collections/alternates', feature)
    .then(res => res.data);

export const useGetInfiniteCollections = (params = {}, queryOptions = {}) => {
  return useInfiniteQuery({
    queryKey: ['infiniteCollections', params],
    queryFn: ({pageParam: nextPageUrl}) =>
      nextPageUrl
        ? graneroInstance.get(nextPageUrl).then(res => res.data)
        : getCollections(params),
    getNextPageParam: lastPage =>
      (lastPage?.links ?? []).find(link => link.rel === 'next')?.href,
    refetchInterval: DURATION_MS.FIVE_MINUTES,
    staleTime: DURATION_MS.FIVE_MINUTES,
    select: data => {
      return {
        ...data,
        collections: data.pages.map(page => page.collections).flat(),
        numberMatched: data.pages[0].numberMatched,
      };
    },
    ...queryOptions,
  });
};

export const useGetFeatureCollections = (params = {}, queryOptions = {}) =>
  useQuery({
    queryKey: queryKeys.list(params),
    queryFn: () => getCollections({params}),
    ...queryOptions,
  });

export const useValidateFeature = (feature, queryOptions = {}) =>
  useQuery({
    queryKey: ['featureCollections', 'validate', feature],
    queryFn: () => validateFeature(feature),
    ...queryOptions,
  });

export const useGetAlternates = (feature, queryOptions = {}) =>
  useQuery({
    queryKey: ['featureCollections', 'alternates', feature],
    queryFn: () => getAlternates(feature),
    ...queryOptions,
  });
